import {
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_STATUS,
    AUTH_SET_PROFILE
} from '../constants/auth.js';
import { transformFirebaseUser } from '../library/util';

export const initialState = {
    // Quick-grab fields
    name: '',

    // Storage Objects
    profile: {}, // Firebase's User Profile, mostly social media details
    nextgenProfile: {}, // Our stored details about user

    // User State
    loggedIn: null,
    isAdmin: false,
    isOrganizer: false,
    isAnonymous: false,
    anonHasProfile: null
};

export function authReducer( state = initialState, action ) {
    switch ( action.type ) {
        case AUTH_LOGIN:
        case AUTH_STATUS:
            return Object.assign( {}, state, {
                profile: transformFirebaseUser( action.user ) || {},
                nextgenProfile: action.nextgenProfile || {},
                loggedIn: ( Object.keys(action.user).length > 1 && !action.user.isAnonymous ) ? true : false,
                isAnonymous: ( action.user && action.user.isAnonymous ) ? true : false,
                anonHasProfile: action.user.isAnonymous ? ( typeof action.nextgenProfile !== 'undefined' ? ( action.nextgenProfile.email && action.nextgenProfile.zip ) : false ) : null,
                isAdmin: ( action.groups && action.groups.indexOf('admins') !== -1 ) ? true : false,
                isOrganizer: ( action.groups && action.groups.indexOf('organizers') !== -1 ) ? true : false,
                isEventModerator: ( action.groups && action.groups.indexOf('event-moderators') !== -1 ) ? true : false,
                canEditEvents: ( action.nextgenProfile && Object.keys(action.nextgenProfile).length > 1 && action.nextgenProfile.can_edit_events ) ? true : false,
                canImportPoints: ( action.nextgenProfile && Object.keys(action.nextgenProfile).length > 1 && action.nextgenProfile.can_import_points ) ? true : false,
                name: ( action.user && !action.user.isAnonymous ) ? ( action.user.displayName || typeof action.user.providerData !== 'undefined' ? action.user.providerData[0].displayName : '' ) : ''
            });

        case AUTH_LOGOUT:
            return Object.assign( {}, state, {
                name: '',
                profile: {},
                nextgenProfile: {},
                isAdmin: false,
                loggedIn: false,
                isAnonymous: false,
                isOrganizer: false,
                anonHasProfile: null
            });

        case AUTH_SET_PROFILE:
            return Object.assign( {}, state, {
                nextgenProfile: action.nextgenProfile,
                anonHasProfile: state.isAnonymous ? true : null
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/auth.js